import { EventBus } from "./../bus/index";

const reponseSymbol = "ipcResponse";

export const ipcSendAndWait = async (
  EVENTNAME: string,
  payload: any,
  timeout: number = 60000
) => {
  return new Promise((resolve, reject) => {
    EventBus.$on(`${EVENTNAME}__${reponseSymbol}`, (res: any) => {
      resolve(res);
    });

    setTimeout(() => {
      reject("timeout: " + timeout);
    }, timeout);

    EventBus.$emit(EVENTNAME, payload);
  });
};

export const ipcResponse = async (EVENTNAME: string, payload: any) => {
  EventBus.$emit(`${EVENTNAME}__${reponseSymbol}`, payload);
};
